export const GreenTrueIcon = ({
  strokeColor = "var(--color-green)",
  ...props
}: any) => (
  <svg {...props} width="10" height="8" viewBox="0 0 10 8" fill="none">
    <path
      id="Vector"
      d="M1 4.00065L3.66667 6.66732L9 1.33398"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
